export default __webpack_public_path__ + "static/widgets-ea68f30a71cc63dbe226dd67e8078f1a.png";